










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import ActionReportContent from '@/components/action_report/ActionReportContent.vue';

@Component({
  components: {
    Header,
    ActionReportContent,
    Footer,
  },
})
export default class ActionReport extends Vue {}
